var _path, _path2, _path3, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzimuthLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 156,
    viewBox: "0 0 41 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3086 69.3643C30.8862 69.3643 39.6836 80.14 39.6836 93.7393C39.6836 105.478 34.7476 116.612 29.7734 124.844C27.2901 128.953 24.8066 132.324 22.9443 134.667C22.0134 135.838 21.2384 136.752 20.6973 137.371C20.5506 137.539 20.4193 137.684 20.3086 137.808C20.1979 137.684 20.0666 137.539 19.9199 137.371C19.3788 136.752 18.6038 135.838 17.6729 134.667C15.8106 132.324 13.327 128.953 10.8438 124.844C5.86957 116.612 0.933594 105.478 0.933594 93.7393C0.933594 80.14 9.73101 69.3643 20.3086 69.3643Z",
    fill: "url(#paint0_linear_436_3706)",
    fillOpacity: 0.7,
    stroke: "#0958D9",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7559 9L20.7559 83",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7559 9L20.7559 83",
    stroke: "#102841",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 148.244,
    r: 6,
    fill: "white",
    stroke: "#102841",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_436_3706",
    x1: 20.3086,
    y1: 68.7393,
    x2: 20.3086,
    y2: 139.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1677FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0958D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzimuthLeaf);
export default __webpack_public_path__ + "static/media/azimuth-leaf.3d5ae5406b945d3abcbf822fec7ddd25.svg";
export { ForwardRef as ReactComponent };